import { Space } from '../../types/listing/space';
import defaultListing from '../../api/defaults/listing';
import { Specifications } from './../../types/listing/specifications';
import { Listing } from '../../types/listing/listing';
import { roundOff } from '../math';
import { Config } from '../../types/config/config';

const fillInvalidValues = (specifications: Specifications): Specifications => {
    if(!specifications) {
        specifications = defaultListing.specifications;
    }
    if (specifications) {
        if (!specifications.totalSpace || isNaN(specifications.totalSpace)) {
            specifications.totalSpace = 0;
        } else {
            specifications.totalSpace = roundOff(Number(specifications.totalSpace));
        }
        
        if (!specifications.salePrice || isNaN(specifications.salePrice)) {
            specifications.salePrice = 0;
        } else {
            specifications.salePrice = roundOff(Number(specifications.salePrice));
        }

        if (!specifications.minPrice || isNaN(specifications.minPrice)) {
            specifications.minPrice = null as unknown as number;
        } else {
            specifications.minPrice = roundOff(Number(specifications.minPrice));
        }

        if (!specifications.maxPrice || isNaN(specifications.maxPrice)) {
            specifications.maxPrice = null as unknown as number;
        } else {
            specifications.maxPrice = roundOff(Number(specifications.maxPrice));
        }
    }
    return specifications;
}
const isPriceRangeApplicable = (listing: Listing, config: Config): boolean => {
    const showMinMaxPriceRange = config.featureFlags.showMinMaxPriceRange || false;
    const leaseTypesForMinPrice = config.featureFlags.listingTypeForMiqSpecificationsMinPrice || [];

    return !!(showMinMaxPriceRange &&
        leaseTypesForMinPrice &&
        leaseTypesForMinPrice.length > 0 &&
        listing.listingType &&
        leaseTypesForMinPrice.includes(listing.listingType.toLowerCase()));
}
export const preProcessMIQListing = (listing: Listing, config: Config): Listing => {
     // Initialize parkings with defaults if not present in MIQ response,
     // so the Parking section renders for any region that has config.parkings.show = true.
    if (!listing.parkings) {
        listing.parkings = defaultListing.parkings;
    }
    if (listing && Array.isArray(listing.spaces) && listing.spaces.length > 0) { 
        let totalSpaces = 0;
        let salePrice = 0;
        let minPrice = 0;
        let maxPrice = 0;
        let measure = "";
        const nSpaces = listing.spaces.length;
        // Arrays to collect min/max prices for range calculation
        const minPrices: number[] = [];
        const maxPrices: number[] = [];

        const shouldApplyPriceRange = isPriceRangeApplicable(listing, config);
        for(let i = 0; i < nSpaces; i++) {
            listing.spaces[i].specifications = fillInvalidValues(listing.spaces[i].specifications);
            if(listing.id > 0 && listing.spaces[i].id === 0) {
                continue;
            }
            totalSpaces += listing.spaces[i].specifications.totalSpace;
            salePrice += listing.spaces[i].specifications.salePrice;            
            if (shouldApplyPriceRange) {
                // For Austria  lease listings - prices to calculate min/max range
                if (listing.spaces[i].specifications.minPrice !== undefined && listing.spaces[i].specifications.minPrice !== null) {
                    minPrices.push(listing.spaces[i].specifications.minPrice);
                }
                if (listing.spaces[i].specifications.maxPrice > 0) {
                    maxPrices.push(listing.spaces[i].specifications.maxPrice);
                }
            } else {
                // sum up the prices
                minPrice += listing.spaces[i].specifications.minPrice;
                maxPrice += listing.spaces[i].specifications.maxPrice;
            }
            // Set measure only if not already set and current is not empty/null
            if (!measure && listing.spaces[i].specifications.measure) {
                measure = listing.spaces[i].specifications.measure;
            }
        }
        listing.specifications = fillInvalidValues(listing.specifications);
        listing.specifications.totalSpace = roundOff(totalSpaces);
        listing.specifications.salePrice = roundOff(salePrice);
        if (shouldApplyPriceRange) {
            if (maxPrices.length > 1) {
                // Austria: Calculate min-max range from maxPrices
                listing.specifications.minPrice = roundOff(Math.min.apply(null, maxPrices));
                listing.specifications.maxPrice = roundOff(Math.max.apply(null, maxPrices));
            }
            else if (maxPrices.length === 1) {
                listing.specifications.minPrice = 0;
                listing.specifications.maxPrice = roundOff(Math.max.apply(null, maxPrices));
            }
        } else {
            listing.specifications.minPrice = roundOff(minPrice);
            listing.specifications.maxPrice = roundOff(maxPrice);
        }
        listing.specifications.measure = measure;
    }
  else {
        // safe gaurding against null spaces.
        listing.spaces = [];
    }
    return listing;
}